/*
  Quick Add: einlegen, Menge sehen, einzeln zuruecknehmen.

  DIE ERSTE FASSUNG WAR FALSCH, und der Fehler ist lehrreich: Dort wurde
  derselbe Knopf nach dem ersten Tipp zum Entfernen-Knopf. Damit liess sich
  keine zweite Tuete derselben Sorte mehr einlegen -- bei einer Mengenstaffel
  ab 5 Stueck genau verkehrt herum. Der Fehlgriff war bedacht, die
  Hauptsache uebersehen.

  Jetzt getrennt:
    Kauf-Knopf   -- legt IMMER eine Einheit ein, unveraendert.
    Zahl darauf  -- wieviel davon im Warenkorb liegt.
    Minus-Knopf  -- erscheint links daneben, sobald etwas drin ist, und
                    nimmt GENAU EINE Einheit heraus.

  Warum nur eine je Tipp: Wer zwoelf Tueten gesammelt hat, darf durch einen
  Fehlgriff nicht zwoelf verlieren.

  Warum ueberhaupt ein Rueckweg: Der Kauf-Knopf ist 53x53 gross und belegt
  8% der Kachel -- ein Fehlgriff ist selten, aber moeglich. Ohne Rueckweg
  muesste man dafuer in den Warenkorb navigieren, und genau daraus entsteht
  das Gefuehl, dass einem etwas untergeschoben wird.

  Vanilla, kein Framework -- Vorgabe fuer dieses Theme.
*/
(function () {
  var KNOPF = '.quick-add__submit[data-variante]';

  /* Varianten-ID -> { key, menge }. Der Schluessel kommt aus /cart.js:
     /cart/change.js nimmt zwar auch eine Varianten-ID, trifft damit aber
     die falsche Zeile, sobald dieselbe Variante mehrfach im Warenkorb
     steht. */
  var zeilen = {};
  var laeuft = false;

  function knoepfe() {
    return [].slice.call(document.querySelectorAll(KNOPF));
  }

  function behaelterVon(b) {
    return b.closest('.image-item__kauf, .quick-add');
  }

  /* Minus-Knopf und Zahl entstehen erst, wenn sie gebraucht werden -- 34
     Kacheln je Seite sollen nicht 34 unsichtbare Knoepfe mitschleppen. */
  function minusVon(b, anlegen) {
    var beh = behaelterVon(b);
    if (!beh) return null;
    var m = beh.querySelector('.mm-minus');
    if (m || !anlegen) return m;
    m = document.createElement('button');
    m.type = 'button';
    m.className = 'mm-minus';
    m.setAttribute('data-fuer', b.getAttribute('data-variante'));
    m.setAttribute('aria-label', (b.getAttribute('data-titel') || '') + ': eine Einheit entfernen');
    /* Kategoriekachel: in das product-form des Kauf-Knopfes, dort sitzt das
       Minus per CSS direkt darueber (bottom: 100%). Keine Messung, also kein
       Versatz durch die schraege Kachel (22.10.2026). Slider: wie bisher vor
       den Kauf-Knopf in den Behaelter, der als Spalte nach oben waechst. */
    var anker = beh.classList.contains('image-item__kauf') ? beh : (b.closest('product-form') || beh);
    anker.insertBefore(m, anker.firstChild);
    return m;
  }

  function zahlVon(b, anlegen) {
    var z = b.querySelector('.mm-anzahl');
    if (z || !anlegen) return z;
    z = document.createElement('span');
    z.className = 'mm-anzahl';
    z.setAttribute('aria-hidden', 'true');   // die Menge steht schon im aria-label
    b.appendChild(z);
    return z;
  }

  function anzeigen() {
    knoepfe().forEach(function (b) {
      var eintrag = zeilen[b.getAttribute('data-variante')];
      var menge = eintrag ? eintrag.menge : 0;
      var name = b.getAttribute('data-titel') || '';

      var z = zahlVon(b, menge > 0);
      if (z) {
        z.textContent = menge > 99 ? '99+' : String(menge);
        z.hidden = menge < 1;
      }

      var m = minusVon(b, menge > 0);
      if (m) m.hidden = menge < 1;

      var beh = behaelterVon(b);
      if (beh) {
        beh.classList.toggle('mm-hat-minus', menge > 0);
        /* Die Masse des Kauf-Knopfes an das CSS durchreichen. Im Slider
           misst er 53px, auf der Kategoriekachel 57px -- Dawns
           .button--secondary bringt dort einen eigenen Rahmen mit. Der
           Minus-Knopf richtet sich danach, statt eine feste Zahl zu raten,
           die auf einer der beiden Kachelarten daneben laege. */
        if (menge > 0 && b.offsetWidth) {
          /* offsetWidth statt getBoundingClientRect: Letzteres liefert die
             TRANSFORMIERTE Groesse. Die Slider-Kacheln stehen unter einer
             Skalierung, dadurch mass der Knopf 49px statt 53px und der
             Minus-Knopf wurde sichtbar kleiner als sein Nachbar. */
          beh.style.setProperty('--mm-kauf-breite', b.offsetWidth + 'px');
          beh.style.setProperty('--mm-kauf-hoehe', b.offsetHeight + 'px');
          /* Abstand des Kauf-Knopfes zur rechten Behaelterkante, damit der
             Minus-Knopf links denselben bekommt. Beide Masse stammen aus
             derselben Messung, sind also gleich skaliert -- die Spiegelung
             stimmt auch dort, wo eine Transformation im Spiel ist. */
          var hb = beh.getBoundingClientRect();
          var bb = b.getBoundingClientRect();
          if (hb.width) {
            beh.style.setProperty('--mm-rand', Math.round(hb.right - bb.right) + 'px');
          }
        }
      }

      /* Der Kauf-Knopf behaelt seine Aufgabe. Nur der Vorlesetext nennt den
         Stand, damit blinde Nutzer ihn nicht erraten muessen. */
      b.setAttribute(
        'aria-label',
        menge > 0
          ? name + ' noch einmal in den Warenkorb legen, ' + menge + ' bereits drin'
          : name + ' in den Warenkorb legen'
      );
    });
  }

  function abgleichen() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (w) {
        zeilen = {};
        (w.items || []).forEach(function (p) {
          var id = String(p.variant_id);
          if (!zeilen[id]) zeilen[id] = { key: p.key, menge: 0 };
          zeilen[id].key = p.key;      // aus der letzten Zeile wird abgezogen
          zeilen[id].menge += p.quantity;
        });
        anzeigen();
      })
      .catch(function () { /* Ohne Warenkorbstand bleibt alles wie es ist. */ });
  }

  /* Die Zahl am Warenkorbsymbol muss mitlaufen, sonst steht dort nach dem
     Zuruecknehmen eine Menge, die es nicht mehr gibt. Dawn liefert den
     Abschnitt einzeln aus -- derselbe Weg, den das Theme selbst nutzt. */
  function bubbleAuffrischen() {
    return fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ziel = document.getElementById('cart-icon-bubble');
        if (ziel && d['cart-icon-bubble']) {
          ziel.innerHTML = new DOMParser()
            .parseFromString(d['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
      })
      .catch(function () {});
  }

  function zurueck(m) {
    var id = m.getAttribute('data-fuer');
    if (laeuft) return;
    laeuft = true;
    m.classList.add('ist-arbeitet');

    /* Erst den aktuellen Stand holen, dann rechnen.

       /cart/change.js kennt nur absolute Mengen, keine Differenz. Auf einem
       zwischengespeicherten Wert zu rechnen ist gefaehrlich: Steht hier noch
       3, waehrend im Warenkorb laengst 1 liegt, setzt "menge - 1" die Menge
       auf 2 -- der Tipp haette dann HINZUGEFUEGT statt entfernt. Genau das
       ist beim Testen passiert. Ein zweiter Reiter oder eine im Warenkorb
       von Hand geaenderte Menge reicht dafuer aus. */
    abgleichen()
      .then(function () {
        var eintrag = zeilen[id];
        if (!eintrag || eintrag.menge < 1) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: eintrag.key, quantity: eintrag.menge - 1 })
        }).then(function (r) { return r.json(); });
      })
      .then(function (ergebnis) {
        if (!ergebnis) return null;
        return Promise.all([abgleichen(), bubbleAuffrischen()]);
      })
      .catch(function () {})
      .then(function () {
        laeuft = false;
        m.classList.remove('ist-arbeitet');
      });
  }

  /* Der Minus-Knopf liegt im selben Behaelter wie der Kauf-Knopf, also ueber
     dem Kachel-Link. stopPropagation haelt den Klick davon ab, zusaetzlich
     die Produktseite zu oeffnen. */
  document.addEventListener('click', function (e) {
    var m = e.target.closest && e.target.closest('.mm-minus');
    if (!m) return;
    e.preventDefault();
    e.stopPropagation();
    zurueck(m);
  });

  /* Nach jedem Einlegen neu abgleichen. Der Toast ist dafuer das
     verlaesslichste Signal: Er oeffnet sich genau dann, wenn Dawn einen
     Artikel gemeldet hat -- unabhaengig davon, welche Fassung von
     product-form.js welche Ereignisse aussendet. */
  var toast = document.getElementById('cart-notification');
  if (toast && window.MutationObserver) {
    new MutationObserver(function () {
      if (toast.classList.contains('active')) abgleichen();
    }).observe(toast, { attributes: true, attributeFilter: ['class'] });
  }

  abgleichen();
  /* Zurueck-Taste holt die Seite aus dem Zwischenspeicher, ohne Skripte neu
     zu starten -- der Warenkorb kann sich zwischenzeitlich geaendert haben. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) abgleichen(); });

  /* Bei geaenderter Breite die Masse neu durchreichen.

     --mm-kauf-breite wird einmal beim Aufbau gesetzt. Der Kauf-Knopf ist auf
     Kategorie- und Suchkacheln am Handy aber kleiner als am Desktop (4,2rem
     statt 5,2rem). Ohne dieses Nachziehen behielt der Minus-Knopf die alte
     Zahl -- gemessen: Kauf 46px neben Minus 57px, nachdem die Breite
     gewechselt hatte. Beim Drehen eines Telefons passiert genau das.

     anzeigen() statt abgleichen(): Es braucht nur die Masse neu, nicht noch
     eine Abfrage des Warenkorbs. */
  var breitenTimer;
  window.addEventListener('resize', function () {
    clearTimeout(breitenTimer);
    breitenTimer = setTimeout(anzeigen, 150);
  });
})();
